<template>
  <div class="iv">
    <div class="iv-head">
      <div>
        <div class="iv-title">Insights</div>
        <div class="iv-sub">Pages built for this tenant. Open one, or ask the agent for a new one.</div>
      </div>
      <div class="iv-actions">
        <input v-model="query" class="iv-search" type="search" placeholder="Find a page">
        <router-link class="iv-btn iv-primary" to="/agent">Build with the agent</router-link>
      </div>
    </div>

    <div v-if="loading" class="iv-note">Loading…</div>
    <div v-else-if="error" class="iv-note iv-error">{{ error }}</div>
    <div v-else-if="!pages.length" class="iv-empty">
      <div class="iv-empty-title">No pages yet</div>
      <div class="iv-empty-body">Ask the agent for a dashboard or a report you will come back to. It saves here and opens on its own URL.</div>
    </div>
    <div v-else class="iv-grid">
      <router-link
        v-for="p in shown"
        :key="p.id"
        class="iv-card"
        :to="`/agent/page/${p.id}`"
      >
        <div class="iv-card-top">
          <span class="iv-kind" :class="'iv-kind-' + p.kind">{{ p.kind === 'dashboard' ? 'Dashboard' : 'Document' }}</span>
          <span v-if="p.category_label" class="iv-cat">{{ p.category_label }}</span>
          <span v-if="p.mine" class="iv-mine">Yours</span>
        </div>
        <div class="iv-card-title">{{ p.title }}</div>
        <div v-if="p.description" class="iv-card-desc">{{ p.description }}</div>
        <div class="iv-card-meta">
          <span v-if="p.kind === 'dashboard'">{{ p.placements }} widget{{ p.placements === 1 ? '' : 's' }}</span>
          <span v-else-if="p.sources">{{ p.sources }} live source{{ p.sources === 1 ? '' : 's' }}</span>
          <span v-else>Static</span>
          <span>·</span>
          <span>{{ when(p.updated_at) }}</span>
          <span v-if="p.created_by">· {{ p.created_by }}</span>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'InsightsV2',
  data() {
    return { pages: [], loading: true, error: '', query: '' };
  },
  computed: {
    shown() {
      const q = this.query.trim().toLowerCase();
      const rows = q
        ? this.pages.filter((p) => `${p.title} ${p.description} ${p.slug}`.toLowerCase().includes(q))
        : this.pages;
      return [...rows].sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at));
    },
  },
  async mounted() {
    try {
      const { data } = await axios.get('/api/impact_analytics/agent-pages/');
      this.pages = data || [];
    } catch (err) {
      this.error = err?.response?.data?.error || 'Pages could not be loaded.';
    } finally {
      this.loading = false;
    }
  },
  methods: {
    when(iso) {
      if (!iso) return '';
      return new Date(iso).toLocaleString([], { month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
    },
  },
};
</script>

<style scoped>
.iv { padding: 24px; background: #f6f5f3; min-height: 100%; }
.iv-head { display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; margin-bottom: 20px; flex-wrap: wrap; }
.iv-title { font-size: 20px; font-weight: 600; color: #1a1918; }
.iv-sub { font-size: 13px; color: #56534d; margin-top: 2px; }
.iv-actions { display: flex; gap: 8px; align-items: center; }
.iv-search { font-size: 13px; padding: 7px 10px; border: 1px solid #dad8d2; border-radius: 8px; background: #fff; min-width: 220px; }
.iv-btn { font-size: 13px; padding: 7px 12px; border: 1px solid #dad8d2; border-radius: 8px; background: #fff; color: #1a1918; text-decoration: none; white-space: nowrap; }
.iv-primary { background: #EF6C3B; border-color: #EF6C3B; color: #fff; }
.iv-note { padding: 32px; font-size: 13px; color: #56534d; }
.iv-error { color: #c23a28; }
.iv-empty { padding: 48px 24px; text-align: center; background: #fff; border: 1px dashed #dad8d2; border-radius: 12px; }
.iv-empty-title { font-size: 15px; font-weight: 600; color: #1a1918; }
.iv-empty-body { font-size: 13px; color: #56534d; margin-top: 6px; max-width: 460px; margin-left: auto; margin-right: auto; }
.iv-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 14px; }
.iv-card { display: flex; flex-direction: column; gap: 6px; padding: 16px; background: #fff; border: 1px solid #e6e4df; border-radius: 12px; text-decoration: none; color: inherit; transition: border-color 0.15s, box-shadow 0.15s; }
.iv-card:hover { border-color: #EF6C3B; box-shadow: 0 2px 10px rgba(26, 25, 24, 0.06); }
.iv-card-top { display: flex; align-items: center; justify-content: space-between; }
.iv-kind { font-size: 10.5px; font-weight: 600; letter-spacing: 0.04em; text-transform: uppercase; padding: 2px 7px; border-radius: 999px; background: #EEF1F7; color: #3E5C8A; }
.iv-kind-dashboard { background: #FBEAE6; color: #C25326; }
.iv-mine { font-size: 10.5px; color: #8b877f; }
.iv-cat { font-size: 10.5px; color: #56534d; margin-left: auto; margin-right: 8px; }
.iv-card-title { font-size: 15px; font-weight: 600; color: #1a1918; line-height: 1.25; }
.iv-card-desc { font-size: 12.5px; color: #56534d; line-height: 1.4; }
.iv-card-meta { display: flex; gap: 6px; flex-wrap: wrap; font-size: 11.5px; color: #8b877f; margin-top: auto; padding-top: 6px; }
</style>
